import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Card, Row, Col, Bubble } from 'tea-component';
// import TipContext from '@home/components/TipContextComponents/TipContext';
import Loading from '@intelligence/components/Loading';
import OverviewCard from '@intelligence/components/OverviewCard';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import useCalcHasEmptyMetric from '../../hooks/useCalcHasEmptyMetric';
import { ratioValueFormat } from '@home/utils/common';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { calcIsEmptyOverviewCard } from '../../../utils';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import { DATASOURCE_NAME, DataSourceBubbleInfo } from '@intelligence/components/DataSourceComponents';

const retentionMetricValueFormatter = (payload?: number) => {
  if (payload === undefined || payload === null) return '0';
  return ratioValueFormat(payload, 0, false, 0, undefined, 3);
};

const EngagementContent = (props: any) => {
  const {
    loading,
    gameId,
    setActiveId,
    setActiveSegment,
    activeId,
    moduleName,
    conditionMarket,
    entityType,
    isOperateRegion,
    showNoDataMetricCard,
    setVendorDataHasEmptyMetric,
    getEngagementData,
    engagementLoading,
    engagementDataList,
    engagementRankLoading: rankLoading,
  } = props;

  const { formatMessage } = useIntlExtend();

  useCalcHasEmptyMetric({
    executable: !(loading || engagementLoading),
    metrics: engagementDataList,
    setHasEmptyMetric: setVendorDataHasEmptyMetric,
  });

  useEffect(() => {
    getEngagementData();
  }, []);

  return (
    <Card className="dbi-performance-summary dbi-kpioverview-card">
      <Card.Body
        title={
          <div className="performance-felx">
            <Bubble
              content={
                <div>
                  <DataSourceBubbleInfo
                    comesFormDom={
                      <>
                        <img
                          className="platform-title-icon"
                          style={{
                            height: '20px',
                            width: '20px',
                            margin: '0 4px',
                            verticalAlign: 'middle',
                          }}
                          src={getDataSourceIcon('ampere')}
                        />
                        {DATASOURCE_NAME.ampere}
                        <div>{formatMessage({ id: 'dbi_combine_engagement_tips1' })}</div>
                        <div>{formatMessage({ id: 'dbi_combine_engagement_tips2' })}</div>
                        <div>{formatMessage({ id: 'dbi_combine_engagement_tips3' })}</div>
                      </>
                    }
                    metricKey={'Avg. monthly playtime (hours),MAU,Lifetime Players,DAU,D1,D7'}
                    dataSource={'Other Vendor'}
                    entityType={entityType}
                  />
                </div>
              }
            >
              <div className="performance-felx">
                <img src={getDataSourceIcon('ampere')} className="dbi-pcGame-select-icon" style={{ height: '20px', width: '20px' }} />
              </div>
            </Bubble>
            {/* <img src={getDataSourceIcon('ampere')} className="dbi-pcGame-select-icon" /> */}
            <span className="performance-felx-text">{formatMessage({ id: 'dbi_other_vendor' })}</span>
            {/* <TipContext
              className="icon-top"
              tipText={formatMessage({ id: 'dbi_combine_engagement_tips' })}
            /> */}
          </div>
        }
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {engagementLoading ? (
          <Loading content={formatMessage({ id: 'common_loading' })} style={{ height: 200, color: '#444' }} />
        ) : (
          <Row>
            {engagementDataList?.map((item: any, index: number) => {
              if (item?.titleIcon === 'viewers') return null;
              if (!showNoDataMetricCard && calcIsEmptyOverviewCard(item)) return null;
              return (
                <Col key={index} span={8}>
                  <OverviewCard
                    key={`indicator${item.titleContent}`}
                    className={classnames({
                      [COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4]: item?.metricUserGuide === 'digitalRevenue',
                    })}
                    titleContent={item.titleContent}
                    titleIcon={item.titleIcon}
                    baseIndicators={item.baseIndicators}
                    numArrowData={item.numArrowData}
                    lineData={item.lineData}
                    lineDom={item.lineDom}
                    rankData={item.rankData}
                    index={index}
                    moduleName={moduleName}
                    entityType={entityType}
                    rankLoading={rankLoading}
                    setActiveId={setActiveId}
                    conditionDate={'month'}
                    conditionMarket={conditionMarket}
                    gameId={gameId}
                    // @ts-ignore
                    activeId={activeId}
                    cardItem={item}
                    setActiveSegment={setActiveSegment}
                    isOperateRegion={isOperateRegion}
                    isShowDataSourceIcon={false}
                    isShowRateTips={true}
                    isTrueActiveSegmentCard={true}
                    yAxisFormatter={
                      ['D1', 'D7'].includes(item?.titleContent) ? retentionMetricValueFormatter : undefined
                    }
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default EngagementContent;
